import { useCallback, useState } from "react"
import { useRevokeAmnestyV1TohMutation } from "../../core/api/toh-social-api"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"

const TohRevokeAmnestyControl = ({ disabled, userId }) => {
    const [open, setOpen] = useState(false)

    const [revoke, { isLoading }] = useRevokeAmnestyV1TohMutation()

    const handleOpenDialog = useCallback(() => {
        setOpen(true)
    }, [setOpen])

    const handleCloseDialog = useCallback(() => {
        setOpen(false)
    }, [setOpen])

    const handleConfirm = useCallback(() => {
        revoke({ userId })
        handleCloseDialog()
    }, [userId, revoke, handleCloseDialog])

    return (
        <>
            <Button
                fullWidth
                color="warning"
                size="small"
                loading={isLoading}
                disabled={disabled}
                onClick={handleOpenDialog}
            >
                Revoke amnesty
            </Button>
            <Dialog fullWidth maxWidth="sm" open={open} onClose={handleCloseDialog}>
                <DialogTitle>
                    Revoke amnesty for '{userId}'
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to revoke amnesty for this player?
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "flex-end", alignItems: "center" }}>
                    <Button variant="contained" color="error" loading={isLoading} disabled={isLoading} onClick={handleConfirm}>
                        Confirm
                    </Button>
                    <Button variant="outlined" onClick={handleCloseDialog}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default TohRevokeAmnestyControl
